import React, { FC, ReactNode, useRef } from 'react';

import classNames from 'classnames';
import { motion } from 'framer-motion';

import useDeviceType from '../../../providers/DeviceType/hooks';
import Header from '../../Header';

import Modal from './index';
import styles from './styles.module.scss';

type MobileModalType = {
	visible?: boolean;
	children: ReactNode;
	title: string | JSX.Element;
	className?: string;
	onClose: () => void;
};

const MobileModal: FC<MobileModalType> = ({ visible, children, title, className, onClose }) => {
	const scrollRef = useRef<HTMLDivElement>(null);
	const { isMobile } = useDeviceType();

	return (
		<Modal className={styles.transparent} visible={visible} onClose={onClose} ownBody>
			<motion.div
				transition={{ duration: 0.3 }}
				initial={isMobile ? { x: 40, opacity: 1 } : { y: 40, opacity: 1 }}
				animate={isMobile ? { x: 0, opacity: 1 } : { y: 0, opacity: 1 }}
				exit={isMobile ? { x: 40, opacity: 1 } : { y: 40, opacity: 1 }}
				className={classNames([styles.mobileModalBody, className])}
				ref={scrollRef}>
				<Header onGoBack={onClose} scrollRef={scrollRef} title={title} />
				{children}
			</motion.div>
		</Modal>
	);
};

export default MobileModal;
